module.exports = __webpack_public_path__ + "static/media/noise.85de087b.png";